import React from 'react';
import Popup from 'reactjs-popup';
import './CartPopup.css'
import { config } from "../../Constants";

const CartPopup = ({ setOpen, open, Price, Quantity, Produit, quantityLabel = "Quantité" }) => {
  const link_write=`${config.url}/${Produit.id_default_image}-home_default/${Produit.link_rewrite}.jpg`;
  return (
    <Popup  open={open} closeOnDocumentClick onClose={setOpen}>

        <div className="modal-cart-header">
          <h3 className="modal-title text-center text-success w-100" id="blockcart-modal-label"><i className="material-icons rtl-no-flip"></i>Produit ajouté au panier avec succès</h3>
        </div>
        <div className="modal-cart-body">
          <div className="image_name">
            <div className="name" > {Produit.name} </div>
            <div className="media">
              <img width="100%" className="image" src={link_write} alt={Produit.name} />
            </div>
          </div>
          <div className="product_info">
            <p className="product_info_titre"> information produit :</p>
            <p className="quantity"><span>{quantityLabel} :</span>&nbsp;<span className="value">{Quantity}</span></p>
            <p className="price"><span>Prix :</span>&nbsp;<span className="value">{Price}&nbsp;MAD </span></p>
          </div>
        </div>
        <div className="modal-cart-footer">
          <button type="button" className="continue-button" onClick={setOpen} data-dismiss="modal">
          <a href = {`${config.url}/2-accueil`} style={{ color: "inherit",textDecoration: "inherit" }}>Continuer mes achats</a></button>
          <a href={`${config.url}/panier?action=show`} className="success-button">Commander</a>
        </div>
    </Popup>
  );
};

export default CartPopup;